import { STATE } from '../constants/stateClasses';
import { scroll } from './locomotive';

const selectors = {
  section: '.js-icons-show-more-section',
  btn: '.js-icons-show-more',
};

const handleIconsShowMore = () => {
  const section = document.querySelector(selectors.section);

  if (!section) return;

  const btn = document.querySelector(selectors.btn);

  btn?.addEventListener('click', () => {
    section.classList.toggle(STATE.active);
    btn.classList.toggle(STATE.active);

    scroll.update();
  });
};

export default handleIconsShowMore;
